export const MOBILE_MIN_WIDTH = 767;